import "dayjs/locale/tr";
import "dayjs/locale/en";

import dayjs from "dayjs";

import { LANGUAGES } from "@/constants/i18next.constants";

const locales = {
  [LANGUAGES.TR]: import("dayjs/locale/tr"),
  [LANGUAGES.EN]: import("dayjs/locale/en"),
} as const;

export const changeDayJsLocale = (language: string) => {
  locales[language as keyof typeof locales].then(() => {
    dayjs.locale(language);
  });
};
